(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      const key = `estasoft:announcement:${this.dataset.key}`;
      try {
        if (window.sessionStorage.getItem(key) === 'closed' && !(window.Shopify && window.Shopify.designMode)) this.hidden = true;
      } catch (error) {
        /* storage blocked: keep the bar visible */
      }
      this.querySelector('[data-dismiss]')?.addEventListener('click', () => {
        this.hidden = true;
        try {
          window.sessionStorage.setItem(key, 'closed');
        } catch (error) {
          /* storage blocked: the bar returns on the next page */
        }
      });
    }
  }
  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-body"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('article-toc')) {
    customElements.define('article-toc', class ArticleToc extends HTMLElement {
      connectedCallback() {
        const target = document.querySelector(this.getAttribute('data-target') || '.prose');
        if (!target) return;
        const headings = Array.from(target.querySelectorAll('h2'));
        const lists = this.querySelectorAll('[data-toc-list]');
        if (headings.length < 2 || !lists.length) {
          this.hidden = true;
          return;
        }
        const used = new Set(Array.from(document.querySelectorAll('[id]'), (el) => el.id));
        const items = [];
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let slug = (heading.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section-' + (index + 1);
            while (used.has(slug)) slug += '-' + (index + 1);
            heading.id = slug;
            used.add(slug);
          }
          items.push({ id: heading.id, text: (heading.textContent || '').trim() });
        });
        for (const list of lists) {
          list.textContent = '';
          for (const item of items) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + item.id;
            a.textContent = item.text;
            li.appendChild(a);
            list.appendChild(li);
          }
        }
        this.hidden = false;
      }
    });
  }

  if (!customElements.get('copy-link')) {
    customElements.define('copy-link', class CopyLink extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-copy]');
        if (this.button) this.button.addEventListener('click', () => this.copy());
      }

      async copy() {
        const url = this.getAttribute('data-url') || window.location.href;
        let done = false;
        try {
          await navigator.clipboard.writeText(url);
          done = true;
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = url;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          try { done = document.execCommand('copy'); } catch (err) { done = false; }
          field.remove();
        }
        if (!done) return;
        const label = this.querySelector('[data-copy-label]');
        const status = this.querySelector('[data-copy-status]');
        const original = label ? label.textContent : '';
        const copied = this.getAttribute('data-copied') || '';
        if (label) label.textContent = copied;
        if (status) status.textContent = copied;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (label) label.textContent = original;
          if (status) status.textContent = '';
        }, 2200);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booking-dialog"] && !Shopify.designMode) return;
  try {
    
  class BookingDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.dialog?.addEventListener('dialog:open', () => this.#load());
    }

    #load() {
      const url = this.dataset.url;
      const frame = this.querySelector('[data-frame]');
      if (!url || !frame || frame.querySelector('iframe')) return;
      let target;
      try { target = new URL(url, window.location.href); } catch { return; }
      if (target.protocol !== 'https:') return;
      const iframe = document.createElement('iframe');
      iframe.className = 'bdlg__frame';
      iframe.title = this.querySelector('.bdlg__title')?.textContent || 'Book a call';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation');
      iframe.addEventListener('load', () => this.querySelector('[data-loading]')?.remove());
      iframe.src = target.href;
      frame.append(iframe);
    }
  }
  if (!customElements.get('booking-dialog')) customElements.define('booking-dialog', BookingDialog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["channels-wall"] && !Shopify.designMode) return;
  try {
    
  /* Channels wall: the pause button stops and starts the moving rows. The motion also pauses on hover and while the band is off screen (see theme.js). */
  class ChannelsWall extends HTMLElement {
    /** @type {HTMLButtonElement | null} */
    #button = null;

    connectedCallback() {
      this.#button = this.querySelector('[data-chwall-toggle]');
      this.#button?.addEventListener('click', this.#toggle);
    }

    disconnectedCallback() {
      this.#button?.removeEventListener('click', this.#toggle);
    }

    #toggle = () => {
      this.toggleAttribute('data-user-paused');
    };
  }

  if (!customElements.get('channels-wall')) customElements.define('channels-wall', ChannelsWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clutch-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Loads the Clutch widget script once, then lets it draw into the .clutch-widget element.
     The frame shows a skeleton while it loads and a link to the Clutch profile if it is blocked or never appears. */
  class ClutchReviews extends HTMLElement {
    static #scriptPromise = null;
    static #scriptLoaded = false;

    /** @type {MutationObserver | null} */
    #observer = null;
    /** @type {IntersectionObserver | null} */
    #viewer = null;
    #timer = 0;
    #retry = 0;
    #done = false;

    connectedCallback() {
      this.widget = this.querySelector('.clutch-widget');
      if (!this.widget) {
        this.dataset.state = 'failed';
        return;
      }
      this.dataset.state = 'loading';
      /* The Clutch script and frame are heavy, so they start only when the section is about to be seen. */
      if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
        this.#viewer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#viewer?.disconnect();
          this.#viewer = null;
          this.#begin();
        }, { rootMargin: '400px 0px' });
        this.#viewer.observe(this);
      } else {
        this.#begin();
      }
    }

    #begin() {
      const failAfter = Number(this.dataset.failAfter) || 10000;
      this.#timer = window.setTimeout(() => this.#fail(), failAfter);

      this.#observer = new MutationObserver(() => this.#check());
      this.#observer.observe(this.widget, { childList: true, subtree: true });

      const alreadyLoaded = ClutchReviews.#scriptLoaded;
      ClutchReviews.#load().then(() => {
        /* A script that loaded earlier has already looked for widgets, so ask it to look again. */
        if (alreadyLoaded) this.#init();
        this.#check();
        /* If nothing has appeared a moment after the script loaded, ask the script to look once more. */
        this.#retry = window.setTimeout(() => {
          if (!this.#done && this.widget && !this.widget.firstElementChild) this.#init();
        }, 1500);
      }).catch(() => this.#fail());
    }

    #init() {
      const api = window.CLUTCHCO;
      if (api && typeof api.Init === 'function') api.Init();
    }

    disconnectedCallback() {
      this.#viewer?.disconnect();
      window.clearTimeout(this.#timer);
      window.clearTimeout(this.#retry);
      this.#observer?.disconnect();
    }

    static #load() {
      if (ClutchReviews.#scriptPromise) return ClutchReviews.#scriptPromise;
      ClutchReviews.#scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://widget.clutch.co/static/js/widget.js';
        script.async = true;
        script.addEventListener('load', () => {
          ClutchReviews.#scriptLoaded = true;
          resolve();
        });
        script.addEventListener('error', () => {
          ClutchReviews.#scriptPromise = null;
          reject(new Error('The Clutch widget script did not load.'));
        });
        document.head.append(script);
      });
      return ClutchReviews.#scriptPromise;
    }

    #check() {
      if (this.#done || !this.widget || !this.widget.firstElementChild) return;
      const frame = this.widget.querySelector('iframe');
      if (frame) {
        /* Wait for the frame itself, so the skeleton does not give way to a blank box. */
        frame.addEventListener('load', () => this.#ready(), { once: true });
        window.setTimeout(() => this.#ready(), 4000);
      } else {
        this.#ready();
      }
    }

    #ready() {
      if (this.#done) return;
      this.#done = true;
      window.clearTimeout(this.#timer);
      window.clearTimeout(this.#retry);
      this.#observer?.disconnect();
      this.dataset.state = 'ready';
    }

    #fail() {
      if (this.#done) return;
      this.#done = true;
      window.clearTimeout(this.#timer);
      window.clearTimeout(this.#retry);
      this.#observer?.disconnect();
      this.dataset.state = 'failed';
    }
  }

  if (!customElements.get('clutch-reviews')) customElements.define('clutch-reviews', ClutchReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  class CookieConsent extends HTMLElement {
    #api = null;
    #storeKey = 'estasoft:consent';

    connectedCallback() {
      this.banner = this.querySelector('[data-banner]');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-form]');
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-consent]');
        if (!button) return;
        event.preventDefault();
        this.#choose(button.getAttribute('data-consent'));
      });
      this.dialog?.addEventListener('dialog:open', () => this.#fillForm());
      if (this.designMode) {
        /* theme editor: selecting the section shows the banner again, even after Accept was clicked in the preview */
        this.onSelect = (event) => {
          if (event.target instanceof Element && event.target.contains(this)) this.#show(true);
        };
        document.addEventListener('shopify:section:select', this.onSelect);
      }
      this.#start();
    }

    disconnectedCallback() {
      if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
    }

    #start() {
      if (this.designMode) {
        this.#show(true);
        return;
      }
      const shopify = window.Shopify;
      if (shopify && typeof shopify.loadFeatures === 'function') {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
          if (error || !shopify.customerPrivacy) {
            this.#fallbackStart();
            return;
          }
          this.#api = shopify.customerPrivacy;
          const current = this.#api.currentVisitorConsent();
          const undecided = !current || current.analytics === '' || current.analytics === undefined;
          this.#show(this.#api.shouldShowBanner() || (this.dataset.everywhere === 'true' && undecided));
        });
      } else {
        this.#fallbackStart();
      }
    }

    #fallbackStart() {
      let stored = null;
      try {
        stored = window.localStorage.getItem(this.#storeKey);
      } catch (error) {
        stored = null;
      }
      this.#show(!stored);
    }

    #show(visible) {
      if (this.banner) this.banner.hidden = !visible;
    }

    #fillForm() {
      if (!this.form) return;
      let current = null;
      if (this.#api) current = this.#api.currentVisitorConsent();
      for (const input of this.form.querySelectorAll('input[type="checkbox"]')) {
        input.checked = Boolean(current) && current[input.name] === 'yes';
      }
    }

    #choose(kind) {
      const consent = { analytics: false, marketing: false, preferences: false };
      if (kind === 'accept') {
        consent.analytics = true;
        consent.marketing = true;
        consent.preferences = true;
      } else if (kind === 'save' && this.form) {
        for (const input of this.form.querySelectorAll('input[type="checkbox"]')) consent[input.name] = input.checked;
      }
      const done = () => {
        this.#show(false);
        if (this.dialog?.open) this.dialog.close();
        try {
          window.localStorage.setItem(this.#storeKey, JSON.stringify(consent));
        } catch (error) {
          /* storage blocked: the choice still applies for this visit */
        }
        document.dispatchEvent(new CustomEvent('estasoft:consent', { detail: consent }));
      };
      if (this.#api) this.#api.setTrackingConsent(consent, done);
      else done();
    }
  }
  if (!customElements.get('cookie-consent')) customElements.define('cookie-consent', CookieConsent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class HeaderNav extends HTMLElement {
    #timer = null;
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKey);
      this.addEventListener('focusout', this.#onFocusOut);
      this.addEventListener('pointerenter', this.#onEnter, true);
      this.addEventListener('pointerleave', this.#onLeave);
      document.addEventListener('click', this.#onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.#onDocClick);
    }
    get #desktop() {
      return window.matchMedia('(min-width: 1100px)').matches;
    }
    #close(except) {
      for (const btn of this.querySelectorAll('button[aria-expanded="true"]')) {
        if (btn === except) continue;
        btn.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(btn.getAttribute('aria-controls') || '');
        if (panel) panel.hidden = true;
      }
    }
    #open(btn) {
      this.#close(btn);
      btn.setAttribute('aria-expanded', 'true');
      const panel = document.getElementById(btn.getAttribute('aria-controls') || '');
      if (panel) panel.hidden = false;
    }
    #onClick = (event) => {
      const btn = event.target.closest('button[aria-expanded]');
      if (!btn) return;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      // On a desktop screen a mouse has already opened the panel by hovering, so its click keeps it open.
      // The keyboard and touch still toggle it.
      if (isOpen && this.#desktop && event.detail > 0 && event.pointerType !== 'touch') return;
      if (isOpen) this.#close();
      else this.#open(btn);
    };
    #onEnter = (event) => {
      if (!this.#desktop || event.pointerType === 'touch') return;
      const item = event.target.closest?.('.hdr__item');
      if (!item) return;
      clearTimeout(this.#timer);
      const btn = item.querySelector('button[aria-expanded]');
      if (btn) this.#open(btn);
      else this.#close();
    };
    #onLeave = () => {
      if (!this.#desktop) return;
      clearTimeout(this.#timer);
      this.#timer = setTimeout(() => this.#close(), 180);
    };
    #onKey = (event) => {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('button[aria-expanded="true"]');
      if (!open) return;
      this.#close();
      open.focus();
    };
    #onFocusOut = (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.#close();
    };
    #onDocClick = (event) => {
      if (!this.contains(event.target)) this.#close();
    };
  }
  if (!customElements.get('header-nav')) customElements.define('header-nav', HeaderNav);

  class MobileMenu extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('button[aria-expanded]');
        if (!btn) return;
        const expand = btn.getAttribute('aria-expanded') !== 'true';
        for (const other of this.querySelectorAll('button[aria-expanded="true"]')) {
          other.setAttribute('aria-expanded', 'false');
          const sub = document.getElementById(other.getAttribute('aria-controls') || '');
          if (sub) sub.hidden = true;
        }
        btn.setAttribute('aria-expanded', String(expand));
        const panel = document.getElementById(btn.getAttribute('aria-controls') || '');
        if (panel) panel.hidden = !expand;
      });
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('data-dialog-open')) return;
        const dialog = this.closest('dialog');
        if (dialog && link.getAttribute('href')?.startsWith('#')) dialog.close();
      });
    }
  }
  if (!customElements.get('mobile-menu')) customElements.define('mobile-menu', MobileMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"] && !Shopify.designMode) return;
  try {
    
  /* Addresses page: country and province selects (Shopify script) and the delete confirmation.
     Without JavaScript the Edit and Delete links open their forms with the #hash, and the delete is a plain form post. */
  class AccAddresses extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => this.#onClick(event));
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('.acc-addr.is-confirming');
        if (open) this.#closeConfirm(open);
      });
      const start = () => this.#initSelectors(0);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
      else start();
    }

    // shopify_common.js is loaded with defer, so it can arrive after this element; try a few times
    #initSelectors(attempt) {
      const Selector = window.Shopify && window.Shopify.CountryProvinceSelector;
      if (!Selector) {
        if (attempt < 30) setTimeout(() => this.#initSelectors(attempt + 1), 100);
        return;
      }
      for (const country of this.querySelectorAll('select[data-acc-country]')) {
        if (country.dataset.ready) continue;
        country.dataset.ready = 'true';
        new Selector(country.id, country.dataset.provinceId, { hideElement: country.dataset.provinceBox });
      }
    }

    #openConfirm(card) {
      card.classList.add('is-confirming');
      const keep = card.querySelector('[data-acc-keep]');
      if (keep instanceof HTMLElement) keep.focus();
    }

    #closeConfirm(card) {
      card.classList.remove('is-confirming');
      const del = card.querySelector('[data-acc-delete]');
      if (del instanceof HTMLElement) del.focus();
    }

    #onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const del = target.closest('[data-acc-delete]');
      if (del) {
        event.preventDefault();
        const card = del.closest('.acc-addr');
        if (card) this.#openConfirm(card);
        return;
      }
      const keep = target.closest('[data-acc-keep]');
      if (keep) {
        event.preventDefault();
        const card = keep.closest('.acc-addr');
        if (card) this.#closeConfirm(card);
        return;
      }
      const yes = target.closest('[data-acc-confirm-delete]');
      if (yes instanceof HTMLElement && window.Shopify && typeof window.Shopify.postLink === 'function') {
        event.preventDefault();
        window.Shopify.postLink(yes.dataset.addressUrl, { parameters: { _method: 'delete' } });
      }
    }
  }
  if (!customElements.get('acc-addresses')) customElements.define('acc-addresses', AccAddresses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  /* #recover opens the reset form: focus its email field.
     #sign-in ("Back to sign in") closes it: drop the markers that keep it open after a sent or failed reset, then focus the sign-in email. */
  (() => {
    const route = () => {
      const hash = window.location.hash;
      if (hash === '#recover') {
        const field = document.getElementById('RecoverForm-email');
        if (field instanceof HTMLElement) field.focus({ preventScroll: true });
      } else if (hash === '#sign-in') {
        document.querySelectorAll('.acc-login [data-acc-open]').forEach((marker) => marker.remove());
        const field = document.getElementById('LoginForm-email');
        if (field instanceof HTMLElement) field.focus({ preventScroll: true });
      }
    };
    window.addEventListener('hashchange', route);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', route, { once: true });
    else route();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["office-map"] && !Shopify.designMode) return;
  try {
    
  /* Shows the map of the chosen office. The first office shows when scripts are off. */
  if (!customElements.get('office-picker')) {
    class OfficePicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.#onChange);
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.#onChange);
      }
      #onChange = (event) => {
        if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
        for (const radio of this.querySelectorAll('input[type="radio"][data-panel]')) {
          const panel = document.getElementById(radio.dataset.panel);
          if (panel) panel.hidden = !radio.checked;
        }
      };
    }
    customElements.define('office-picker', OfficePicker);
  }

  /* Pauses the route line and pin motion while the map is off screen. */
  if (!customElements.get('omap-frame')) {
    class OmapFrame extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.removeAttribute('data-paused');
            else this.setAttribute('data-paused', '');
          });
        });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
    customElements.define('omap-frame', OmapFrame);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search"] && !Shopify.designMode) return;
  try {
    
  class PredictiveSearch extends HTMLElement {
    #controller = null;
    #timer = null;

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-input]');
      this.results = this.querySelector('[data-results]');
      this.status = this.querySelector('[data-status]');
      this.clear = this.querySelector('[data-clear]');
      this.limit = Number(this.dataset.limit) || 6;
      this.types = (this.dataset.types || 'page,article').split(',');
      this.i18n = this.#readJson('[data-i18n]', {});
      this.input?.addEventListener('input', () => this.#onInput());
      this.input?.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        this.dialog?.close();
      });
      this.clear?.addEventListener('click', () => {
        this.input.value = '';
        this.#onInput();
        this.input.focus();
      });
      this.dialog?.addEventListener('dialog:open', () => {
        this.input?.focus();
        this.input?.select();
      });
      this.dialog?.addEventListener('close', () => this.#reset());
    }

    #readJson(selector, fallback) {
      try {
        return JSON.parse(this.querySelector(selector)?.textContent || '');
      } catch (error) {
        return fallback;
      }
    }

    #reset() {
      this.#controller?.abort();
      if (this.input) this.input.value = '';
      this.#onInput();
    }

    #onInput() {
      const term = this.input.value.trim();
      this.clear.hidden = !this.input.value;
      clearTimeout(this.#timer);
      if (!term) {
        this.#controller?.abort();
        this.results.hidden = true;
        this.results.replaceChildren();
        this.status.textContent = '';
        return;
      }
      this.#timer = setTimeout(() => this.#search(term), 180);
    }

    async #search(term) {
      this.#controller?.abort();
      this.#controller = new AbortController();
      this.dialog.classList.add('sdlg__loading');
      const params = new URLSearchParams({ q: term, 'resources[type]': this.types.join(','), 'resources[limit]': String(this.limit), 'resources[limit_scope]': 'each' });
      let pages = [];
      let articles = [];
      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.#controller.signal, headers: { Accept: 'application/json' } });
        if (response.ok) {
          const data = await response.json();
          const found = data?.resources?.results || {};
          pages = found.pages || [];
          articles = found.articles || [];
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
      this.dialog.classList.remove('sdlg__loading');
      this.#render(term, pages, articles);
    }

    #icon(name) {
      const paths = {
        layout: '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/><path d="M3.5 9.5h17M9.5 9.5v10"/>',
        doc: '<path d="M7 3.5h7l4 4V20a.5.5 0 0 1-.5.5h-10A.5.5 0 0 1 7 20V3.5z"/><path d="M14 3.5V8h4M9.5 12.5h5M9.5 16h5"/>',
      };
      const wrap = document.createElement('span');
      wrap.className = 'sdlg__row-ico';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths[name] || paths.layout}</svg>`;
      return wrap;
    }

    #highlight(target, text, term) {
      const index = text.toLowerCase().indexOf(term.toLowerCase());
      if (index < 0) {
        target.textContent = text;
        return;
      }
      target.append(document.createTextNode(text.slice(0, index)));
      const mark = document.createElement('b');
      mark.textContent = text.slice(index, index + term.length);
      target.append(mark, document.createTextNode(text.slice(index + term.length)));
    }

    #group(title, rows, term, iconFor) {
      if (!rows.length) return null;
      const section = document.createElement('div');
      section.className = 'sdlg__group';
      const heading = document.createElement('p');
      heading.className = 'sdlg__group-title';
      heading.textContent = title;
      const list = document.createElement('div');
      for (const row of rows) {
        const link = document.createElement('a');
        link.className = 'sdlg__row';
        link.href = row.url;
        const label = document.createElement('span');
        label.className = 'sdlg__row-title';
        this.#highlight(label, row.title, term);
        const kind = document.createElement('span');
        kind.className = 'tag sdlg__row-kind';
        kind.textContent = title;
        link.append(this.#icon(iconFor(row)), label, kind);
        list.append(link);
      }
      section.append(heading, list);
      return section;
    }

    #render(term, pages, articles) {
      const total = pages.length + articles.length;
      this.results.replaceChildren();
      this.results.hidden = false;
      if (!total) {
        const empty = document.createElement('p');
        empty.className = 'sdlg__empty';
        empty.textContent = (this.i18n.none || '').replace('__TERMS__', () => term);
        this.results.append(empty);
        this.status.textContent = empty.textContent;
        return;
      }
      const groups = [
        this.#group(this.i18n.pages, pages, term, () => 'layout'),
        this.#group(this.i18n.articles, articles, term, () => 'doc'),
      ].filter(Boolean);
      this.results.append(...groups);
      const foot = document.createElement('div');
      foot.className = 'sdlg__foot';
      const all = document.createElement('a');
      all.className = 'lnk';
      all.href = `${this.dataset.searchUrl}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
      all.textContent = (this.i18n.seeAll || '').replace('__TERMS__', () => term);
      foot.append(all);
      this.results.append(foot);
      const label = total === 1 ? this.i18n.countOne : this.i18n.countOther;
      this.status.textContent = (label || '').replace(/\d+/, String(total));
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["readiness-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('readiness-quiz')) {
    /** Plus readiness check: one question at a time, a plain result, no score shown. Answers stay in the page and in sessionStorage for the hand-off to the brief. */
    class ReadinessQuiz extends HTMLElement {
      connectedCallback() {
        this.storeKey = this.dataset.store || 'estasoft.plusCheck';
        this.total = Number(this.dataset.total) || 0;
        this.fitsMin = Number(this.dataset.fits) || 3;
        this.talkMin = Number(this.dataset.talk) || 2;
        this.panels = Array.from(this.querySelectorAll('[data-rq-panel]'));
        this.card = this.querySelector('[data-rq-card]');
        this.results = Array.from(this.querySelectorAll('[data-rq-result]'));
        this.error = this.querySelector('[data-rq-error]');
        this.back = this.querySelector('[data-rq-back]');
        this.next = this.querySelector('[data-rq-next]');
        this.live = this.querySelector('[data-rq-live]');
        this.index = 0;
        if (!this.panels.length || !this.next) return;

        this.next.addEventListener('click', () => this.onNext());
        if (this.back) this.back.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelectorAll('[data-rq-retake]').forEach((button) => button.addEventListener('click', () => this.retake()));
        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLInputElement && event.target.matches('[data-rq-answer]')) this.clearError();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && event.target instanceof HTMLInputElement && event.target.matches('[data-rq-answer]')) {
            event.preventDefault();
            this.onNext();
          }
        });

        this.prefill();
        this.show(0, false);
      }

      store(value) {
        try {
          if (value === null) window.sessionStorage.removeItem(this.storeKey);
          else window.sessionStorage.setItem(this.storeKey, JSON.stringify(value));
        } catch (error) {
          /* private mode: the check still works */
        }
      }

      saved() {
        try {
          const raw = window.sessionStorage.getItem(this.storeKey);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      }

      /** "Review or change them" from the brief form: the answers come back checked. */
      prefill() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('review') !== '1') return;
        const data = this.saved();
        if (!data || !Array.isArray(data.answers)) return;
        data.answers.forEach((value, i) => {
          const panel = this.panels[i];
          const input = panel && Array.from(panel.querySelectorAll('[data-rq-answer]')).find((el) => el.value === String(value));
          if (input instanceof HTMLInputElement) input.checked = true;
        });
      }

      chosen(panel) {
        return panel.querySelector('[data-rq-answer]:checked');
      }

      show(index, focus) {
        const last = this.panels.length - 1;
        this.index = Math.max(0, Math.min(index, last));
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== this.index;
        });
        if (this.back) this.back.hidden = this.index === 0;
        const label = this.next.querySelector('[data-rq-next-label]');
        if (label) label.textContent = this.index === last ? this.next.dataset.labelResult : this.next.dataset.labelNext;
        this.clearError();
        const panel = this.panels[this.index];
        const heading = panel.querySelector('[data-rq-heading]');
        if (focus && heading instanceof HTMLElement) heading.focus({ preventScroll: false });
        if (focus && this.live) {
          const count = panel.querySelector('.rq__count');
          this.live.textContent = count ? count.textContent : '';
        }
      }

      clearError() {
        if (this.error) this.error.hidden = true;
        const group = this.panels[this.index] && this.panels[this.index].querySelector('[data-rq-group]');
        if (group) {
          group.removeAttribute('aria-invalid');
          group.removeAttribute('aria-describedby');
        }
      }

      onNext() {
        const panel = this.panels[this.index];
        if (!this.chosen(panel)) {
          if (this.error) {
            if (!this.error.id) this.error.id = 'rq-error-' + Math.random().toString(36).slice(2, 8);
            this.error.hidden = false;
            const group = panel.querySelector('[data-rq-group]');
            if (group) {
              group.setAttribute('aria-invalid', 'true');
              group.setAttribute('aria-describedby', this.error.id);
            }
            const first = panel.querySelector('[data-rq-answer]');
            if (first instanceof HTMLElement) first.focus();
          }
          return;
        }
        if (this.index < this.panels.length - 1) this.show(this.index + 1, true);
        else this.finish();
      }

      /** Counts the answers that point to Plus. The visitor never sees the number. */
      finish() {
        let score = 0;
        let onPlus = false;
        const answers = [];
        const lines = [];
        const rows = [];
        this.panels.forEach((panel) => {
          const input = this.chosen(panel);
          if (!(input instanceof HTMLInputElement)) return;
          answers.push(input.value);
          const topic = panel.dataset.topic || '';
          const title = input.dataset.title || '';
          if (input.hasAttribute('data-signal')) score += 1;
          if (input.hasAttribute('data-plus')) onPlus = true;
          lines.push(topic ? topic + ': ' + title : title);
          rows.push({ topic, title, signal: input.hasAttribute('data-signal') });
        });
        let key = score >= this.fitsMin ? 'fits' : score >= this.talkMin ? 'talk' : 'std';
        if (key === 'std' && onPlus) key = 'talk';
        const result = this.results.find((el) => el.dataset.rqResult === key) || this.results[0];
        if (!result) return;

        const title = (result.dataset.title || '').replace(/\.\s*$/, '');
        this.store({
          result: key,
          title,
          count: answers.length,
          answers,
          summary: title + '; ' + answers.length + ' answers: ' + lines.join('; '),
        });
        this.fillRows(result, rows);
        this.results.forEach((el) => {
          el.hidden = el !== result;
        });
        if (this.card) this.card.hidden = true;
        result.hidden = false;
        const heading = result.querySelector('.rq__rt');
        if (heading instanceof HTMLElement) heading.focus({ preventScroll: false });
        if (this.live) this.live.textContent = title;
      }

      fillRows(result, rows) {
        const box = result.querySelector('[data-rq-rows]');
        if (!box) return;
        const signalLabel = this.live ? this.live.dataset.signalLabel || '' : '';
        box.textContent = '';
        rows.forEach((row) => {
          const line = document.createElement('div');
          line.className = 'rq__row';
          const key = document.createElement('div');
          key.className = 'rq__row-k';
          key.textContent = row.topic;
          const value = document.createElement('div');
          value.className = 'rq__row-v';
          value.appendChild(document.createTextNode(row.title));
          if (row.signal && signalLabel) {
            const holder = document.createElement('span');
            holder.className = 'rq__row-s';
            const badge = document.createElement('span');
            badge.className = 'badge';
            badge.textContent = signalLabel;
            holder.appendChild(badge);
            value.appendChild(holder);
          }
          line.append(key, value);
          box.appendChild(line);
        });
      }

      retake() {
        this.store(null);
        this.panels.forEach((panel) => {
          panel.querySelectorAll('[data-rq-answer]').forEach((input) => {
            if (input instanceof HTMLInputElement) input.checked = false;
          });
        });
        this.results.forEach((el) => {
          el.hidden = true;
        });
        if (this.card) this.card.hidden = false;
        this.show(0, true);
      }
    }
    customElements.define('readiness-quiz', ReadinessQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
